import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightBlue = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.54537 11.3012L5.52264 10.2899L9.07378 6.73875H0.15332V5.26147H9.07378L5.52264 1.71602L6.54537 0.698975L11.8465 6.00011L6.54537 11.3012Z",
		fill: "#176ECB"
	})
});
const ForwardRef = forwardRef(SvgArrowRightBlue);
export { ForwardRef as ReactComponent };
